import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Loading from '../../core/Loading';
import CalendarHeader from '../../core/CalendarHeader';

import { loadCalendarEvents } from '../../../actions/events';

const getDate = (date, monthStatus) => {
  const fromDate = new Date(date);
  const monthSelected = monthStatus === 'prev' ? -1 : 1;

  fromDate.setMonth(fromDate.getMonth() + monthSelected);

  const toDate = new Date(fromDate);

  toDate.setMonth(toDate.getMonth() + 1);

  return {
    fromDate,
    toDate
  };
};

class EventsCalendarHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false
    };
  }

  navigateToMonth = (_, fromDate, toDate) => {
    const { loadEvents, onNavigate } = this.props;

    this.setState({ loading: true });

    loadEvents(fromDate, toDate).then(() => {
      this.setState({ loading: false });
    });

    onNavigate(_, fromDate);
  };

  render() {
    const { label, date, showNavigators } = this.props;

    return (
      <div>
        {this.state.loading ? (
          <Loading />
        ) : (
          <CalendarHeader
            id="calendar-header"
            month={label.split(' ')[0]}
            year={label.split(' ')[1]}
            showNavigators={showNavigators}
            onLeftClick={_ => {
              const { fromDate, toDate } = getDate(date, 'prev');
              this.navigateToMonth(_, fromDate, toDate);
            }}
            onRightClick={_ => {
              const { fromDate, toDate } = getDate(date, 'next');
              this.navigateToMonth(_, fromDate, toDate);
            }}
          />
        )}
      </div>
    );
  }
}

EventsCalendarHeader.propTypes = {
  label: PropTypes.string,
  date: PropTypes.instanceOf(Date),
  onNavigate: PropTypes.func,
  loadEvents: PropTypes.func,
  showNavigators: PropTypes.bool
};

const mapStateToProps = ({ events }) => ({
  showNavigators: events.showNavigators
});

const mapDispatchToProps = dispatch => ({
  loadEvents: (fromDate, toDate, newDate) =>
    loadCalendarEvents(dispatch, fromDate, toDate, null, newDate)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EventsCalendarHeader);
